<template>
    <div class="content" v-if="isShow">
        <div class="child-content" v-for="(cardBodyConfig,index) in cardBodyConfigs" :key="index">
            <div class="card-body-container">
                <!--左侧图片-->
                <div class="picture">
                    <img :src="cardBodyConfig.cardOption.leftImg">
                </div>
                <!--右侧商品组轮播-->
                <div class="right">
                    <div class="mal-swiper">
                        <swiper :options="swiperOptions[index]">
                            <swiper-slide v-for="(goods,index) in cardBodyConfig.goodsGroup" :key="index"><product-card :items="goods"></product-card></swiper-slide>
                        </swiper>
                    </div>
                    <div class="pagination-bar">
                        <div class="swiper-pagination" :id ="'cbp'+index"></div>
                        <a v-if="cardBodyConfig.cardOption.moreUrl" :href="cardBodyConfig.cardOption.moreUrl">{{constant.more}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import 'swiper/dist/css/swiper.css'
    import ProductCard from './ProductCard.vue'
    export default {
        components: {
            'swiper' :swiper,
            'swiper-slide': swiperSlide,
            'product-card':ProductCard
        },
        data() {
             let swiperOptionArr = [];
             let cardBodyConf = this.$store.state.malMainPageConfig.cardBody;
             
             let autoplayObject = false;
             for(var i =0;i< cardBodyConf.length;i++) {
                if(cardBodyConf[i].cardOption.autoplay===true){
                    autoplayObject = {
                        delay:cardBodyConf[i].cardOption.delay,//默认3秒切换一次
                        disableOnInteraction :false
                    }
                }
                swiperOptionArr[i] = {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    autoplay: autoplayObject,
                    speed: cardBodyConf[i].cardOption.speed,
                    pagination: {
                        el: '#cbp' + i,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '" style="margin: 0 5px; width: 22px;height:6px;background: #FC8555;border-radius: 9px;outline:none"></span>';
                        },
                    }
                };
            }
            return {
                cardBodyConfigs : cardBodyConf,
                swiperOptions: swiperOptionArr,
                constant : this.$store.state.malMainPageConfig.constant
            }
        },
        computed:{
            isShow : function(){
                return this.$store.state.malMainPageConfig.isShowSelf
            }
        }
        
    }
</script>

<style scoped lang="scss">
    .content{
        width: 100%;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        align-items: center
    }
    .content .child-content{
        margin-bottom: 10px;
    }
  .card-body-container{
    display: flex;
    width: 1200px;
    justify-content: flex-start;
    align-items: center;
  }

  .card-body-container .picture{
    width: 100px;
    height: 429px;
    z-index: 1;
  }
  .card-body-container .picture img{
    width: 100px;
    height: 429px;
    z-index: 1;
  }
  .card-body-container .right{
    width: 1100px;
    height: 429px;
    left: 100px;
    background: #ffffff60;
  }
  .right .swiper-pagination {
    left: 0;
    width: 1075px;
    position: relative;
  }
  .right .mal-swiper{
    width: 1100px;
    height: 408px;
  }

  .pagination-bar {
      height: 20px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      bottom: 5px;
      position: relative;
      margin-left: 25px;
  }
  .pagination-bar a {
      position: absolute;
      right: 0px;
      width: 60px;
      height: 22px;
      z-index: 12;
      text-decoration: none;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #5E80EB;
      line-height: 16px;

  }

</style>
